import isEmpty from 'lodash/isEmpty';
import APIService from '../APIService';
import { API_HOST, apiEndpoints } from '../../constants/APIConstants';

export default {
  getReviews(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      else
        APIService.request(
          {
            method: 'GET',
            url: `${API_HOST}${apiEndpoints.REVIEWS}?jobCityWorkLocationId=${options.jobCityWorkLocationId}`,
            isAuthenticated: true,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
    });
  },
  postReview(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      if (isEmpty(`${options.jobCityWorkLocationId}`)) reject(new Error('Invalid Params'));
      else {
        APIService.request(
          {
            method: 'POST',
            data: options,
            url: `${API_HOST}${apiEndpoints.REVIEWS}`,
            isAuthenticated: true,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
      }
    });
  },
  storeVotes(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      else if (isEmpty(options.reviewId)) reject(new Error('review ID required'));
      else {
        APIService.request(
          {
            method: 'POST',
            data: options,
            url: `${API_HOST}${apiEndpoints.REVIEWS}/${options.reviewId}/${options.voteType}`,
            isAuthenticated: true,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
      }
    });
  },
  getVoteCount(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      else
        APIService.request(
          {
            method: 'GET',
            url: `${API_HOST}${apiEndpoints.REVIEWS}/${options.reviewId}/${options.voteType}`,
            isAuthenticated: true,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
    });
  },
};
